import { layout } from '../../App.routing'

export const liveSportSegment = layout.component({
    type: 'hera',
    props: {
        hasBorder: true,
        verticalSpacing: 'xl',
        sectionHeader: {
            heading: 'Live Sport',
            headingUrl: '/sport/live',
            section: 'sport',
        },
        dataDefinitionArgs: {
            type: 'curation',
            name: 'live-sports-hub',
            offset: 0,
            pageSize: 4,
        },
    },
})
